// Content + data for Radio App Consultancy — an independent web development, software consultancy & app development studio (one-time, per-project, no subscription).

export const PLANS = [
  {
    id: "setup",
    name: "Project Setup & Kickoff",
    price: 149.99,
    unit: "one-time • per project",
    badge: "Most Popular",
    featured: true,
    perks: [
      "Complete project setup — repository, environments, CI/CD & architecture blueprint",
      "Requirement analysis and tech-stack recommendation for your product",
      "One-time charge covers one project kickoff",
      "Building multiple products? Add units at checkout — price multiplies per unit",
      "15-day free-fix guarantee if any setup issue comes up",
    ],
    cta: "Start your project",
  },
  {
    id: "consultancy",
    name: "Software Consultation",
    price: 49.99,
    unit: "one-time • expert consultation",
    badge: "Advice",
    featured: false,
    perks: [
      "One-on-one consultation on web, mobile & custom software",
      "Independent advice on architecture, tech stack & product roadmap",
      "Code / product review with best-practice guidance",
      "One-time charge — no recurring fees",
      "Follow-up help within your 15-day guarantee",
    ],
    cta: "Book consultation",
  },
  {
    id: "radio",
    name: "Radio App Consultancy",
    price: 119.99,
    unit: "one-time • radio setup & guidance",
    badge: "Radio",
    featured: false,
    perks: [
      "Expert consultancy for your radio & streaming radio apps",
      "Independent guidance to choose the right setup & plan",
      "Setup & activation help across phone, car and streaming devices",
      "One-time charge — no subscription, ever",
      "15-day free-fix guarantee",
    ],
    cta: "Book radio consultancy",
  },
  {
    id: "custom",
    name: "Custom Amount",
    custom: true,
    price: 0,
    unit: "you choose the amount",
    badge: "Flexible",
    featured: false,
    perks: [
      "Pay the one-time amount agreed for your project or milestone",
      "Perfect for custom development or consulting packages",
      "No subscription, no auto-renewal",
      "Includes your 15-day free-fix guarantee",
    ],
    cta: "Enter your amount",
  },
];

export function planToParams(plan) {
  return `?plan=${encodeURIComponent(plan.name)}&amount=${plan.price}`;
}

export const HERO_SLIDES = [
  { img: "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=1600&q=80", label: "Modern web apps, built to scale" },
  { img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1600&q=80", label: "iOS & Android apps that ship" },
  { img: "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?auto=format&fit=crop&w=1600&q=80", label: "Cloud & DevOps done right" },
];

export const FEATURES = [
  { icon: "Code2", title: "Web development", text: "Fast, responsive websites and web apps built with modern stacks like React, Next.js and Node — from landing pages to full-scale platforms." },
  { icon: "Smartphone", title: "Mobile app development", text: "Native and cross-platform iOS & Android apps built with React Native and Flutter — smooth, reliable, and store-ready." },
  { icon: "Layers", title: "Custom software & SaaS", text: "Tailored software, dashboards and SaaS products designed around your workflow, with secure APIs and scalable cloud architecture." },
  { icon: "LifeBuoy", title: "15-day free-fix guarantee", text: "If anything isn't working right after delivery, report it within 15 days and we fix it free — no extra charge." },
];

export const COMPARISON = [
  { feature: "One-time project charge (no subscription)", savi: true, others: false },
  { feature: "Independent tech & architecture consulting", savi: true, others: false },
  { feature: "Full-stack web, mobile & software delivery", savi: true, others: false },
  { feature: "15-day free issue-fix guarantee", savi: true, others: false },
  { feature: "Transparent, milestone-based delivery", savi: true, others: true },
];

export const WAYS = [
  { icon: "Code2", title: "Web platforms", text: "Marketing sites, dashboards, portals and web apps engineered to scale.", img: "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=900&q=80" },
  { icon: "Smartphone", title: "Mobile apps", text: "Cross-platform iOS & Android apps your users will love to use.", img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=900&q=80" },
  { icon: "Cloud", title: "Cloud & DevOps", text: "Deployment, CI/CD and cloud setup on AWS, GCP, Vercel and more.", img: "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?auto=format&fit=crop&w=900&q=80" },
];

export const FOOTER_COLUMNS = [
  { title: "Services", links: ["Web Development", "Mobile Apps", "Custom Software", "UI/UX Design", "Cloud & DevOps", "Maintenance & Support"] },
  { title: "Solutions", links: ["Startups & MVPs", "SaaS Platforms", "E-commerce", "Enterprise Software", "API Integrations"] },
  { title: "Company", links: ["About", "How We Work", "Case Studies", "Careers", "Partners"] },
  { title: "Support", links: ["Help Center", "Contact Us", "Report an Issue", "Documentation", "Service Care"] },
  { title: "Resources", links: ["Blog", "Tech Stack", "Pricing", "FAQ"] },
];

export const ANNOUNCEMENTS = [
  { strong: "One-time service:", text: "Radio consultancy, web & app development, and genuine antivirus — pay once, no subscription.", cta: "Get started" },
  { strong: "15-day guarantee:", text: "Any issue after delivery? We fix it free within 15 days.", cta: "Learn more" },
];

// Authorized antivirus reseller badge (SAVI SERVICES — AntivirusSales.com, since 2019)
export const RESELLER = {
  text: "Authorized AntivirusSales.com Reseller since 2019",
  short: "Authorized Reseller · Since 2019",
};

// NOTE: prices below are placeholders — update them to your actual antivirus pricing.
export const ANTIVIRUS_PLANS = [
  {
    id: "av-1d1y",
    name: "1 Device / 1 Year",
    price: 149.99,
    unit: "one-time • 1 device · 1 year",
    badge: "Starter",
    featured: false,
    perks: [
      "Real-time antivirus & malware protection",
      "Web, email & phishing protection",
      "Free installation & activation help",
      "Unlimited support included",
      "Genuine, licensed software",
    ],
  },
  {
    id: "av-3d1y",
    name: "3 Devices / 1 Year",
    price: 299.99,
    unit: "one-time • 3 devices · 1 year",
    badge: "Most Popular",
    featured: true,
    perks: [
      "Everything in 1 Device",
      "Protect up to 3 devices",
      "Ransomware & identity protection",
      "Unlimited priority support",
    ],
  },
  {
    id: "av-5d2y",
    name: "5 Devices / 2 Year",
    price: 499.99,
    unit: "one-time • 5 devices · 2 years",
    badge: "Best Value",
    featured: false,
    perks: [
      "Everything in 3 Devices",
      "Protect up to 5 devices for 2 years",
      "Advanced firewall & performance tune-up",
      "24/7 unlimited support",
    ],
  },
  {
    id: "av-custom",
    name: "Custom Amount",
    custom: true,
    price: 0,
    unit: "you choose the amount",
    badge: "Flexible",
    featured: false,
    perks: [
      "Pay the agreed amount for your antivirus package",
      "Any brand or device count",
      "Genuine, licensed software",
      "Full setup & activation help",
    ],
  },
];

